import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const TinkoffSolidSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 1H1V12.0642C1 14.9008 2.51138 17.5225 4.96937 18.9408L12 23L19.0306 18.9408C21.4854 17.5225 23 14.9008 23 12.0642V1ZM7.03641 6.82743V6.82422L7.0332 6.82743H7.03641ZM7.03641 6.82743V10.2641C7.50811 9.73145 8.36167 9.37206 9.34038 9.37206H10.4025V13.3735C10.4025 14.4389 10.1137 15.3694 9.68373 15.8829H14.3077C13.8809 15.3694 13.5921 14.4389 13.5921 13.3767V9.37527H14.6543C15.633 9.37527 16.4897 9.73466 16.9582 10.2673V6.82743H7.03641Z", fill: "var(--magritte-ui-icon-color)" }) }));
const TinkoffSolidSize24 = hoc(forwardRef(TinkoffSolidSize24Component), 'TinkoffSolidSize24');

export { TinkoffSolidSize24 as default };
//# sourceMappingURL=TinkoffSolidSize24.js.map
